import { createFileRoute } from '@tanstack/react-router';

import { AcquiringSettingsPage } from '../../../features/finance/ui/acquiring-settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/acquiring')({
  // Эквайринг — только `finance.manage`: terminal key, пароль терминала и счёт для поступлений.
  beforeLoad: requireSettingsPermission('finance.manage'),
  component: AcquiringSettingsPage,
});
